import React from 'react'

import { Icon, HelpCircleIcon } from 'components/shared/Icon/Icon'
import type { IconSource } from 'components/shared/Icon/Icon'
import { Tooltip } from 'components/shared/Tooltip/Tooltip'

import styles from './LabelWithTooltip.module.scss'
import cx from 'classnames'

type LabelWithTooltipProps = {
  children?: React.ReactNode
  icon?: IconSource
  size?: number
  tagName?: React.ElementType
  tooltip?: React.ReactNode
  className?: string
}

export const LabelWithTooltip = ({
  children,
  icon = HelpCircleIcon,
  size = 16,
  tagName,
  tooltip,
  className,
}: LabelWithTooltipProps) => {
  const Element = tagName ?? 'h3'

  return (
    <Element className={cx(styles.heading, className)}>
      <span className={styles.label}>{children}</span>
      {tooltip ? (
        <Tooltip hasArrow>
          <Tooltip.Anchor className={styles.anchor}>
            <Icon className={styles.icon} {...{ icon, size }} />
          </Tooltip.Anchor>
          <Tooltip.Note note={tooltip} />
        </Tooltip>
      ) : null}
    </Element>
  )
}
